module.exports = __webpack_public_path__ + "images/pages/for_business/sp/btn_4_e6fb6552a42418048aca4bd0a935752a.png";